module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-Regular-54ff0fb300071273e73f623aea2bad6e.ttf";